import routes from 'actions/routes';
import { generateReadOneActionCreator} from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

export default {
    readOpportunities: generateReadOneActionCreator(routes.API_OPPORTUNITY_TAB, ACTION_NAMES.OPPORTUNITY_TAB)
};
